import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { CustomPage as CustomPageState } from '../../../publicSite/publicSite.module'
import { storyPageWidget } from './storyPage.widget'
import { Drupal } from '../../drupal/api'

export type StoryPageDatasheetState = {
  name?: string
  age?: string
  disease?: string
}

export type StoryPageState = {
  datasheet: AsyncState<StoryPageDatasheetState>
} & CustomPageState

export const storyPageState = (slug: string): StoryPageState => {
  return {
    widget: storyPageWidget,
    datasheet: loadingAsyncState(() => Drupal.getStoryPageDatasheet('en', slug)),
  }
}